import React from "react";
import "./WhatSetsApart.css";
import { FaArrowRight } from "react-icons/fa6";
import { Link } from "react-router-dom";


const WhatSetsApart = () => {
  return (
    <section className="wsa-section">

      <div className="wsa-container">

        {/* Title */}
        <h2 className="wsa-title">What Sets Us Apart</h2>

        {/* Paragraph */}
        <p className="wsa-text">
          We provide fully managed services—from recruitment and training to monitoring 
          and quality control. Our approach ensures predictability, lower downtime 
          and stable operations for your facility.
        </p>

        {/* Button */}
        <Link to="/services" className="wsa-btn">
  Explore Our Complete Service Portfolio
  <FaArrowRight className="wsa-icon" />
</Link>

      </div>

    </section>
  );
};

export default WhatSetsApart;
